import api from "../../../Utils/interface";

// Plain API calls only. Side effects (toasts, navigation, store updates) live
// in the React Query hooks under ./Hook.

const buildQuoteFormData = (payload) => {
  // rm_name is display-only; the server derives the RM from the logged-in user.
  const { rm_name, ...quote } = payload;
  const fd = new FormData();
  fd.append("entity", JSON.stringify(quote));
  fd.append("entitytype", "QOT");
  return fd;
};

// createQuote takes a JSON body; a multipart form gets a 415 from the server.
export const createQuote = (payload) => {
  // rm_name is display-only; the server derives the RM from the logged-in user.
  const { rm_name, ...quote } = payload;
  return api
    .post(
      `/quote/createQuote`,
      { ...quote, entitytype: "QOT" },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((response) => response.data);
};

// Re-Quote: new attributes on a saved quote. The server updates variant_json,
// insurer and premium; AG and product stay as saved.
export const updateQuote = ({ entityid, variant_json, oem, status }) =>
  api
    .post(
      `/quote/updateQuote`,
      { entity_id: entityid, variant_json, oem, status },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((response) => response.data);

// Quote plus product, AG, RM and insurer names. QOT is not registered in the
// entity master, so /entity/read cannot load quotes.
export const getQuote = (quoteId) =>
  api
    .get(`/quote/getQuote`, { params: { quoteId } })
    .then((response) => response.data);

export const convertQuote =({ quoteId, customerId }) => {
  const fd = new FormData();
  fd.append("quoteId", quoteId);
  if (customerId) fd.append("customerId", customerId);
  return api
    .post(`/quote/convertQuote`, fd)
    .then((response) => response.data);
};

// Same entity create used by the AG Member screen (entity type AGM)
export const createQuoteMember = (member, organizationid) => {
  // Only send filled fields, like the AG Member form does; empty strings would
  // fail server-side parsing for date and numeric columns.
  const filled = Object.fromEntries(
    Object.entries(member).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  );
  const fd = new FormData();
  fd.append(
    "entity",
    JSON.stringify({ ...filled, entitytype: "AGM", organizationid })
  );
  fd.append("entitytype", "AGM");
  return api.post(`/entity/create`, fd).then((response) => response.data);
};

export const downloadQuote = (payload) =>
  api
    .post(`/agsp/quote/downloadQuote`, buildQuoteFormData(payload), {
      responseType: "blob",
    })
    .then((response) => response.data);

export const sendQuote = (payload) =>
  api
    .post(`/agsp/quote/sendQuote`, buildQuoteFormData(payload))
    .then((response) => response.data);

export const sendQuoteLink = (quoteId) =>
  api
    .get(`/agsp/quote/sendQuoteLink`, { params: { quoteId } })
    .then((response) => response.data);

// Distinct values of a column, e.g. state or city of AG members
export const getDropdownValues = (entityType, columnName) => {
  const fd = new FormData();
  fd.append("entityType", entityType);
  fd.append("columnName", columnName);
  return api
    .post(`/entity/getDropdownData`, fd)
    .then((response) =>
      Array.isArray(response.data)
        ? response.data
            .filter((item) => item)
            .map((item) => ({ label: item, value: item }))
        : []
    );
};

// Raw accessible AG list (includes each AG organization id)
export const getAccessibleAgList = (ownerId) =>
  api
    .get(`/agsp/order/getAllAccessibleAgByOwnerId`, { params: { ownerId } })
    .then((response) => (Array.isArray(response.data) ? response.data : []));
